<template>
    <tr>
        <td class="px-6 py-4">{{ invitee.email }}</td>
        <td class="px-6 py-4">{{ invitee.updated_at | date }}</td>
        <td class="px-6 py-4 flex justify-between items-center">
            <button-white @click="resend(invitee.id)" v-show="!loading">
                E-Mail erneut senden
            </button-white>
            <confirm-dialog @confirmed="remove"  v-show="!loading">
                <template v-slot:question>Soll die Einladung an {{ invitee.email }} wirklich gelöscht werden?</template>
                <template v-slot:header>Einladung löschen</template>
                <template v-slot:confirm>
                    <button-delete>
                        <i class="fa fa-trash mr-2"></i> Einladung löschen
                    </button-delete>
                </template>
                <button-delete>
                    <i class="fa fa-trash mr-2"></i> Einladung löschen
                </button-delete>
            </confirm-dialog>
            <loading is_small v-show="loading"></loading>
        </td>
    </tr>
</template>

<script>
import ButtonWhite from "./UI/ButtonWhite.vue";
import Loading from "./UI/Loading.vue";
import ButtonDelete from "./UI/ButtonDelete.vue";
import ConfirmDialog from "./UI/ConfirmDialog.vue";
export default {
    name: "UserInviteSingle",
    components: {ConfirmDialog, ButtonDelete, Loading, ButtonWhite},
    props: ['invitee'],

    data:() => ({
        loading: false,
    }),

    methods: {
        resend(id) {
            this.loading = true;
            this.$http.put(`/admin/user_invitees/${id}`)
                .then(() => {
                    this.loading = false;
                    this.$root.$emit('alert', 'Benutzer erneut eingeladen.');
                })
                .catch(error => {
                    this.loading = false;
                    this.$root.$emit('error', error);
                })
        },
        remove() {
            this.loading = true;
            this.$http.delete(`/admin/user_invitees/${this.invitee.id}`)
                .then(() => {
                    this.loading = false;
                    this.$root.$emit('alert', 'Einladung gelöscht.');
                    this.$emit('reload');
                })
                .catch(error => {
                    this.loading = false;
                    this.$root.$emit('error', error);
                })
        }
    }
}
</script>

<style scoped>

</style>
